import styled from 'styled-components/macro';
import { colorCoreGray300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel2 } from '@yme/tokens/typography';
export const NoResultsWrapperStyled = styled(FlexWrapper) `
  border-top: 1px solid ${colorCoreGray300};

  ${ADAPTIVE.minWidth.desktop} {
    border-top: none;
  }
`;
export const HeadingLevel2Styled = styled(HeadingLevel2) `
  margin-bottom: 32px;

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: 40px;
  }
`;
